import React, { PropsWithChildren, useEffect } from 'react';
import GuidanceMenu from '../Menu/index';
import { cn } from '../../../../utils/styles';
import { getGuidanceSettingsFromStorage } from '../../../../components/Pages/Home/SettingsModal/storage-utils';
import MenuContextProvider from '../../../context/menu';
import AccountContextProvider from '../../../context/account';

export default function MainGuidanceLayout({ children }: PropsWithChildren) {
  /** Set custom theme variables from session storage */
  useEffect(() => {
    const { primaryColor, secondaryColor } = getGuidanceSettingsFromStorage();
    const guidance = document.getElementById('guidance');

    if (guidance) {
      if (primaryColor) {
        guidance.style.setProperty('--primary', primaryColor);
      }
      if (secondaryColor) {
        guidance.style.setProperty('--secondary', secondaryColor);
      }
    }
  }, []);

  return (
    <main
      className={cn('guidance w-full min-h-screen bg-primary-foreground grid lg:grid-cols-[215px_1fr] align-top')}
      id="guidance"
    >
      <MenuContextProvider>
        <AccountContextProvider>
          <GuidanceMenu />
          {children}
        </AccountContextProvider>
      </MenuContextProvider>
    </main>
  );
}
